// api/user.js
import request from "/src/utils/request"

// 获取首页轮播图图片
export function getBanner() {
    return request({
        url: "/banner?sort=asc",
        method: "get",
    })
}

// 快捷方块
export function getQuick() {
    return request({
        url: "/block?sort=asc&limit=10",
        method: "get",
    })
}

// 获取分类
export function getCategory(e) {
    return request({
        url: `/shoptype?limit=${e.limit}&sort=${e.sort}`,
        method: "get",
    })
}

// 获取商品列表
export function getGoodsList(e) {
    return request({
        url: `/shop?limit=${e.limit}&orderby=${e.orderby}&sort=${e.sort}`,
        method: "get",
    })
}

// 合作伙伴
export function getPartner() {
    return request({
        url: "/getIndexCooperate?sort=asc",
        method: "get",
    })
}

// 开关
export function getThemes(e) {
    return request({
        url: `/getTheme?type=${e.type}`,
        method: "get",
    })
}

// 地图
export function getMap() {
    return request({
        url: "/getMap",
        method: "get",
    })
}